export class ShippingLoadDetailError {
  root: string[];
  load: string[];
  totalRate: string[];
  commodity: string[];
  fuelRateByProgram: string[];
  rateSeeker: string[];
}
